import Api from '@/services/Api'

export default {
  fetchPosts (data) {
    return Api().get('/company/' + data.id + '/posts?offset=' + data.offset + '&amount=' + data.amount + '&type=' + data.type)
  },
  fetchGifts (params) {
    return Api().get('/posts/gift', {params})
  },
  fetchBillboardPosts (data) {
    return Api().get('/company/' + data.id + '/billboard-posts')
  },
  fetchAdById (data) {
    return Api().get('/posts/' + data.id)
  },
  fetchTags (data) {
    return Api().get('/company/'+ data.id + '/tags')
  },
  deletePromotion (data) {
    return Api().delete('/company/' + data.companyId + '/posts/' + data.promotionId)
  },
  deleteBillboardAd (data) {
    return Api().delete('/company/' + data.CompanyId + '/billboard-posts/' + data.id)
  },
  editPromotion(data) {
    return Api().put('/company/' + data.companyId + '/posts/' + data.id, data)
  },
  editBillboardAd(data) {
    return Api().put('/company/' + data.CompanyId + '/billboard-posts/' + data.id, data)
  },
  createBillboardAd(data) {
    return Api().post('/company/' + data.CompanyId + '/billboard-posts/create', data)
  },
  create(data) {
    return Api().post('/company/' + data.companyId + '/posts/create', data)
  },
  createCampaign(data) {
    return Api().post('/company/' + data.CompanyId + '/campaign', data)
  },
  fetchMedias(data) {
    return Api().get('/company/' + data.companyId + '/medias')
  },
  upload(newFile) {
    return Api().post('/media/upload/', { files: newFile })
  },
  mediaUrlUpload(url, platform) {
    return Api().post('/media/upload/url', { url, platform })
  },
  deleteMedia(id) {
    return Api().delete(`/media/${id}`)
  },

  // Admin
  getAllWifi () {
    return Api().get('/posts')
  },
  getAllBillboard () {
    return Api().get('/billboard/posts/all')
  },
  deleteWifi (data) {
    return Api().delete('/posts/' + data.id)
  },
  editWifi(data) {
    return Api().put('/posts/' + data.id, data)
  },
  createBillboard(data) {
    return Api().post('/billboard/posts', data)
  },
  deleteBillboard(data) {
    return Api().delete('/billboard/posts/' + data.id)
  },
  editBillboard(data) {
    return Api().put('/billboard/posts/' + data.id, data)
  },
}
